module.exports = __webpack_public_path__ + "static/img/html5.e9fba34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skills/html5.png
// module id = 517
// module chunks = 1